import { registerPlugin } from '@capacitor/core';

// Plugin nativo in-project, iOS-only (Android não tem swipe-back de WebView —
// o voltar de lá é botão/gesto do sistema, sem travessia animada).
// Implementação: ios/App/App/BridgeViewController.swift (classe no mesmo
// arquivo do view controller pra não mexer no project.pbxproj).
//
//   setSwipeBackEnabled({ enabled: boolean })
//     - controla webView.allowsBackForwardNavigationGestures em runtime.
//     - o Player desliga durante o fullscreen-por-CSS (a animação de snapshot
//       do gesto "quica" pra página anterior ao consumir a entrada descartável,
//       que não tem snapshot próprio) e religa em toda saída de fullscreen.
//
// Chamadas devem ser gateadas por $isIos — não há implementação Android/web.
export const VxlNavGestures = registerPlugin('VxlNavGestures', {});

export default VxlNavGestures;
